import { IData } from 'shared/types/dataType'

export const whyJoinUsCommitments = ({ language, breakpoint }: IData) => {
  return {
    fr: {
      header: {
        banner: {
          title: 'Pourquoi nous rejoindre',
          image: {
            alt: 'actualites',
            urlMobile: '/assets/images/career/why-join-us/why-join-us-mobile.png',
            urlDesktop: '/assets/images/career/why-join-us/why-join-us-desktop.png'
          }
        }
      }
    },
    en: {
      header: {
        banner: {
          title: 'Why join us?',
          image: {
            alt: 'actualites',
            urlMobile: '/assets/images/career/why-join-us/why-join-us-uk-mobile.png',
            urlDesktop: '/assets/images/career/why-join-us/why-join-us-uk-desktop.png'
          }
        }
      }
    }
  }[language]
}
